import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';
import { environment } from 'environment';
import { Subject, fromEvent, merge } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';

@Directive({ selector: '[tenTokenizerErrorListener]', standalone: true })
export class TokenizerErrorListenerDirective implements AfterViewInit, OnDestroy {
  @Output() public tokenizerError: EventEmitter<Event>;
  private destroy$: Subject<void>;

  constructor(private elementRef: ElementRef) {
    this.tokenizerError = new EventEmitter<Event>();
    this.destroy$ = new Subject<void>();
  }

  public ngAfterViewInit() {
    const iframeLoaded$ = fromEvent<Event>(this.elementRef.nativeElement, 'load');
    const postMessageReceived$ = fromEvent(window, 'message').pipe(
      filter((event: MessageEvent) => environment.tokenizerUrl.startsWith(event.origin))
    );

    iframeLoaded$
      .pipe(take(1), delay(2000), takeUntil(merge(postMessageReceived$, this.destroy$)))
      .subscribe(this.tokenizerError);
  }

  public ngOnDestroy() {
    this.destroy$.next();
  }
}
